"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollHeader = void 0;
const scrollHeader = () => {
    const header = document.querySelector('header.site-header');
    let previousScrollPosition = 0;
    const getScrollState = () => {
        let scrollState = 'top';
        let scrollPosition = window.scrollY;
        if (scrollPosition > 128 && scrollPosition > previousScrollPosition) {
            scrollState = 'down';
        }
        if (scrollPosition > 128 && scrollPosition < previousScrollPosition) {
            scrollState = 'up';
        }
        previousScrollPosition = scrollPosition;
        return scrollState;
    };
    const handleScroll = () => {
        header.setAttribute('data-scroll', getScrollState());
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
};
exports.scrollHeader = scrollHeader;
